import { AuctionUserNotification } from "./types";

export const AUCTION_STATE = [
  "upcoming",
  "preview",
  "listed",
  "live",
  "closed",
] as const;

export const OPEN_AUCTION_STATES = ["upcoming", "preview", "listed", "live"];

export const AUCTION_USER_NOTIFICATION_TO_DISPLAY_NAME: Record<
  AuctionUserNotification,
  string
> = {
  upcoming: "Upcoming",
  preview: "Preview",
  accepting_opening_bids: "Accepting Opening Bids",
  live: "Live",
  filled: "Filled",
};
